export const SectionTitle = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  return (
    <h2 className="font-evogria text-primary text-2xl sm:text-4xl md:text-5xl lg:text-6xl uppercase flex-shrink min-w-0">
      {children}
    </h2>
  )
}
